import { IShellEvent } from './IShellEvent';
import { ShellCommunicationEvents } from '@shared/generalInterfaces';
import { Injectable } from '@angular/core';
import { ApplicationNavigationService } from 'app/services/shell/application-navigation/application-navigation.service';

@Injectable({ providedIn: 'root' })
export class ClosingRejectedEvent implements IShellEvent {

	constructor(private readonly applicationNavigationService: ApplicationNavigationService) {
	}

	get eventName(): string {
		return ShellCommunicationEvents.ClosingRejected;
	}

	handleCustomEvent(event: any) {
		this.applicationNavigationService.stopClosingAppTimer(event.eventHeader.publisher);
	}

	handlePostMessage(event): void {
	}
}